
<div id="topbar" class="align-items-center d-flex fixed-top">
  <div class="container-fluid">
    <div class="row topbar-info align-items-center">
      <!-- <div class="col-4">
        <div class="device-time d-block d-sm-none">
          <p>device time <small>14:37:00</small></p>
        </div>
      </div> -->
      <div class="col-6 logo">
        <!-- <div class="device-time">
          <p style="width: max-content;">
            <a style="color: rgb(230, 230, 230);" href="javascript:void(0);" routerLink="/home"><i class="icofont-home"></i> HOME</a> 
            | <label class="switch1"><input type="checkbox"><span class="slider1 round1"></span></label>
          </p>
        </div> -->
        <a href="javascript:void(0);" routerLink="/home">
          <img class="img-fluid" src="assets/images/logo.png">
        </a>
      </div>
      <!-- <div class="col-6 col-md-4 logo">
          
      </div> -->
      <div class="col-6 login-time">
        <button class="btn_deposit desktop_div" *ngIf="depoWithdrawCondition() && isLogin()" routerLink="/deposit"><img src="http://speedcdn.io/assets/mangoo777-client/deposit.svg">deposit</button>
        <button class="btn_withdrawal desktop_div" *ngIf="depoWithdrawCondition() && isLogin()" routerLink="/withdraw"><img src="http://speedcdn.io/assets/mangoo777-client/withdraw.svg"> withdraw</button>
        <a routerLink="/rules" class="rules desktop_div" *ngIf="userData && userData?.wager_active != 0">
          rules
        </a>
        <span class="mx-2" (click)="_message.succmessage('res.message');">{{currentDateTime}}</span>
        <button class="login" (click)="openLogin()" *ngIf="!isLogin()">login</button>
        <button class="login" routerLink="/signup" *ngIf="!isLogin() && env.host.signUpActive">sign up</button>
        <!-- <button class="login" (click)="openLogin()" *ngIf="!isLogin() && env.host.signUpActive">Forgot?</button> -->
        <div class="btn-group top-user-menus" *ngIf="isLogin()">
          <button type="button">
              <em>{{userData?.username}}</em>
              <span class="blnc">
                Bal: <b>{{fixedPostDecimal(userData?.available_balance)}}</b>
                <div>Exp: <b>{{fixedPostDecimal(positiveVal(userData?.expose))}}</b></div>
              </span>
          </button>
          <button type="button" class="dropdown-toggle user_profiles" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="icofont-ui-user"></i>
          </button>
          <!-- <span class="exposure_bal">Expo. {{positiveVal(roundVal(userData?.expose))}}</span> -->
          <div class="dropdown-menu">
            <div class="balance-information" *ngIf="userData && userData?.wager_active != 1">
                <div class="balance-row">
                    <div class="balance-text-left">available credit:</div>
                    <div class="balance-price" [ngClass]="{'credit': userData?.available_balance > 0,'debit': userData?.available_balance < 0}">{{fixedPostDecimal(userData?.available_balance)}}</div>
                </div>
                <div class="balance-row" >
                    <div class="balance-text-left">credit limit:</div>
                    <div class="balance-price">{{fixedPostDecimal(userData?.balance)}}</div>
                </div>
                <div class="balance-row" >
                    <div class="balance-text-left">winning</div>
                    <div class="balance-price" [ngClass]="{'credit': userData?.pl > 0,'debit': userData?.pl < 0}">{{userData?.pl}}</div>
                </div>
                <div class="balance-row" routerLink="/market-analysis">
                    <div class="balance-text-left">net exposer:</div>
                    <div class="balance-price" [ngClass]="userData?.expose >= 0 ? 'credit' : 'debit'">{{userData?.expose}}</div>
                </div>
            </div>
            <div class="balance-information" *ngIf="userData && userData?.wager_active == 1">
              <div class="balance-title">
                <i aria-hidden="true" class="icofont-bank"></i> Balance Information
              </div>
              <div class="balance-row"><!-- bal+pl+expo -->
                  <div class="balance-text-left">Wallet Amount <small>(Inclusive bonus)</small></div>
                  <div class="balance-price">{{balInfo.wall_amt}}</div>
              </div>
              <div class="balance-row" routerLink="/market-analysis">
                 <div class="balance-text-left">Net Exposure</div>
                 <div class="balance-price">{{balInfo.net_expo}}</div>
             </div>
             <div class="balance-row">
                 <div class="balance-text-left">Bonus</div>
                 <div class="balance-price">{{balInfo.bonus}}</div>
             </div>
             <div class="balance-row"> <!-- pl+expo -->
                 <div class="balance-text-left">Available Withdrawal</div>
                 <div class="balance-price">{{balInfo.avail_withdrawal}}</div>
             </div>
            </div>

            <div class="ab_rae_btns" *ngIf="userData && userData?.wager_active == 1">
                <button routerLink="/bonus-list" class="ab_btns" tabindex="0">Awaiting Bonus<span>{{balInfo.await_bonus}}</span></button>
                <button routerLink="/reffer-and-earn" class="rae_btns" tabindex="0">REFER AND EARN</button>
            </div>
            
            <!-- <a class="dropdown-item" href="javascript:void(0);" routerLink="/bonus-list">bonus list</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/reffer-and-earn">reffer and earn</a> -->
            <a *ngIf="userData && userData?.wager_active == 1" class="dropdown-item" href="javascript:void(0);" (click)="openBonusRule()">Bonus rule</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/account/profile">profile</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/my-bets">my bets</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/reports/account-statement">account statement</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/reports/profit-loss">profit & loss</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/stake-setting">stake setting</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/change-password">change password</a>
            <a class="dropdown-item mobile_div" href="javascript:void(0);" routerLink="/rules">Rules</a>
            <a class="logout" href="javascript:void(0);" (click)="logOut()">log out</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row depo_withd" *ngIf="depoWithdrawCondition() && isLogin()">
  <div class="col-6">
    <button class="btn_deposit" routerLink="/deposit"> <img src="http://speedcdn.io/assets/mangoo777-client/deposit.svg"> deposit</button>
  </div>
  <div class="col-6">
    <button class="btn_withdrawal" routerLink="/withdraw"><img src="http://speedcdn.io/assets/mangoo777-client/withdraw.svg"> withdraw</button>
  </div>
</div>

<a *ngIf="!router.url.includes('event/detail/') && depoWithdrawCondition() && wpLink != ''" class="whatsapp_link" [href]="wpLink" target="_blank"><img src="assets/images/wp_support.png"></a>

<div class="modal fade promotion-popup" bsModal #afterLoginModal="bs-modal"
    [config]="{show: false , backdrop: false, ignoreBackdropClick: false}" tabindex="-1" role="dialog" aria-labelledby="">
    <div class="modal-dialog bookModal app_version">
        <div class="modal-content modal-content-centered">
            <div class="modal-body p-0">
                <button style="position: absolute;right: 13px;top: 1px;color: #fff;font-size: 21px;" type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="afterLoginModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <a href="javascript:void(0)" (click)="afterLoginModal.hide()">
                    <img src="http://speedcdn.io/assets/mangoo777-client/popup.jpg" style="width: 100% !important;">
                </a>
            </div>
        </div>
    </div>
</div>